export default {
    namespaced: true,
    state: () => ({
        headerFullHeight: 58, //px
        footerFullHeight: 80, //px
    }),
    getters: {
        reservedMargins: (state, getters, rootState, rootGetters) => {
            let topHeight = 0;
            let bottomHeight = 0;

            if (rootGetters.onlyDesktopVisible) {
                topHeight = state.headerFullHeight;
                bottomHeight = state.footerFullHeight;
            }

            return {
                topHeight,
                bottomHeight,
            };
        },
        /**
         * Vertical space a page can occupy, in pixels.
         * @returns {number}
         */
        availablePageHeight: (state, getters, rootState) => {
            return rootState.device.height - getters.reservedMargins.topHeight - getters.reservedMargins.bottomHeight;
        },
    },
};
